import { SelectItem } from "@mantine/core/lib/Select/types";

import {
  DeskCollectionResponse,
  GetDeskCollectionInvoicesQuery,
  GetDeskCollectionsQuery,
} from "../../graphql/generated.ts";

export type DeskCollection =
  GetDeskCollectionsQuery["deskCollections"]["data"][0];
export type DeskCollectionInvoice =
  GetDeskCollectionInvoicesQuery["invoices"]["data"][0];

export const deskCollectionResponseOptions: SelectItem[] = [
  { value: DeskCollectionResponse.YesPaid, label: "Yes - Paid" },
  { value: DeskCollectionResponse.YesNotPaid, label: "Yes - Not Paid" },
  { value: DeskCollectionResponse.NoPaid, label: "No - Paid" },
  { value: DeskCollectionResponse.NoNotPaid, label: "No - Not Paid" },
];
